import { encode } from "./HelperFunctions";

type ActionRouteItem = {
  action?: string;
  id?: number | string;
  url_slug?: string | null;
};

const ACTION_PREFIXES: Record<string, string> = {
  payment_link: "pl_",
  invoice: "inv_",
  quotes: "qt_",
  agreement: "agr_",
};

export const getActionNavigationSlug = (
  item: ActionRouteItem,
  clusterId: string,
  timestamp: number = Date.now()
): string => {
  if (item.url_slug) {
    return item.url_slug;
  }

  const prefix = ACTION_PREFIXES[item.action || ""] || "agr_";
  return encode(`${item.id}_${clusterId}_${timestamp}`, prefix);
};
